import { Button, DropdownOption } from "@ofrz/ui-package";
import { StatusBadge } from "components/status-badge";
import { FilterTab } from "components/tab-filter/tab-filter.props";
import { COLORS } from "libs/colors";
import { DataTypes } from "libs/enums";
import { InvoiceModel } from "libs/models/invoice";
import { LookupModel } from "libs/models/lookup-model";
import { DownloadIcon } from "static/images/svgs/download-icon";
import { ViewIcon } from "static/images/svgs/view-icon-svg";
import translate from "../../utils/translations";

export const DynamicSearchKeys = [
  { InvoiceNumber: DataTypes.String, Status: DataTypes.String },
];
export const invoicesReportHeaders = [
  {
    title: translate("Invoice_No_Text", "Invoice No TODO"),
    dataIndex: "invoiceNumber",
    key: "invoiceNumber",
    isSortable: false,
  },
  {
    title: translate("Client_Text", "Client TODO"),
    dataIndex: "clientName",
    key: "clientName",
    isSortable: false,
  },
  {
    title: translate("Status_Text", "Status TODO"),
    dataIndex: "invoicesStatus",
    key: "invoicesStatus",
    isSortable: false,
  },
  {
    title: translate("QTY_Text", "QTY TODO"),
    dataIndex: "totalCardSold",
    key: "totalCardSold",
    isSortable: false,
  },
  {
    title: translate("Amount_Due_Text", "Amount Due TODO"),
    dataIndex: "total",
    key: "total",
    isSortable: false,
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    isSortable: false,
  },
];
export const getInvoicesList = (
  clientsData: InvoiceModel[],
  onView: (id: string) => void,
  onDownload: (id: string) => void
) => {
  const data = [];
  for (var i = 0; i < clientsData.length; i++) {
    const request = clientsData[i];
    const row: Record<string, any> = {
      ...request,
      invoicesStatus: getInvoiceStatus(request.invoicesStatus),
      totalCardSold: request.totalCardSold?.toLocaleString(),
      total: request.total?.toLocaleString(),
      actions: (
        <div className="flex">
          <Button
            className={`${COLORS.TEXT_FORM} !p-0 m-2`}
            onClick={() => onDownload(request.fileId)}
          >
            <DownloadIcon />
          </Button>
          <Button
            className={`${COLORS.TEXT_FORM} !p-0 m-2`}
            onClick={() => onView(request.id)}
          >
            <ViewIcon />
          </Button>
        </div>
      ),
    };
    data.push(row);
  }
  return data;
};

export const invoicesTabFilters: FilterTab[] = [
  {
    id: 0,
    value: translate("View_All_Text", "View All TODO"),
  },
  {
    id: 2,
    value: translate("Paid_Text", "Paid TODO"),
  },
  {
    id: 1,
    value: translate("UnPaid_Text", "UnPaid TODO"),
  },
];
const getInvoiceStatus = (status: string) => {
  switch (status) {
    case "Paid":
      return (
        <div>
          <StatusBadge
            status={`${status}`}
            style="bg-[#ECFDF3] text-green-700 border-green-400"
          />
        </div>
      );
    case "UnPaid":
      return (
        <div>
          <StatusBadge
            status={`${status}`}
            style="bg-[#FEE2E2] text-red-700 border-red-400"
          />
        </div>
      );
    default:
      return (
        <div>
          <StatusBadge
            status={`${status}`}
            style="bg-gray-100 text-gray-700 border-gray-400"
          />
        </div>
      );
  }
};

export const getInvoiceFilterStatus = (status: number) => {
  switch (status) {
    case 2:
      return "Paid";
    case 1:
      return "UnPaid";
    default:
      return "View All";
  }
};
